
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LoadingOverlay from '../components/LoadingOverlay';
import moment from 'moment';
import {getTimeDifference} from '../utils/dates';







 class BookingConfirmationForm extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            modalTimeChange: false,
          };
      
          this.toggle = this.toggle.bind(this);
    }

    toggle(property) {
        let newState = {};
        newState[property] = !this.state[property];
        this.setState(newState);
    }





    render(){

        let {startDate,untilDate}=this.props.locationDetail;
        const {handleDateChange, isLoading, pricingModel, offeringType} =this.props;
        return(
            <div className="row">
               {/* <LoadingOverlay loading={isLoading} spinnerStyle={{ top: "20%" }}> */}
                    <div className="col-12">
                        <div className="row mt-2 hr-bottom__after">
                            <div className="col-6 mt-2">
                                Park anytime after
                            </div>
                            <div className="col-6 text-right">
                                {offeringType == 0 && 
                                    <strong>{moment(pricingModel.breakdown[0].startTime).format('DD/MM/YYYY HH:mm')}</strong>
                                }
                                {offeringType == 1 && 
                                    <strong>{moment(startDate).format('DD/MM/YYYY HH:mm')}</strong>
                                }
                                <span><button className="btn btn-link px-0"  onClick={() => handleDateChange()}><i className="fa fa-pencil icon-right"></i></button></span>
                            </div>
                        </div>
                        <div className="row hr-bottom__after">
                            <div className="col-6 mt-2">
                                Exit anytime before
                            </div>
                            <div className="col-6 text-right">
                                {offeringType == 0 && 
                                    <strong>{moment(pricingModel.breakdown[0].endTime).format('DD/MM/YYYY HH:mm')}</strong>
                                }
                                {offeringType == 1 && 
                                    <strong>{moment(untilDate).format('DD/MM/YYYY HH:mm')}</strong>
                                }
                                <span>
                                    <button className="btn btn-link px-0"  onClick={() => handleDateChange()}>
                                        <i className="fa fa-pencil icon-right"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                        <div className="row mt-2 mb-2">
                            <div className="col-6">
                                Duration <br/> 
                            </div>
                            <div className="col-6 text-right">
                                { offeringType == 0 && 
                                    <strong>
                                        { pricingModel.breakdown[0].duration >= 24
                                            ? `${Math.floor(pricingModel.breakdown[0].duration / 24)} day${pricingModel.breakdown[0].duration >= 48 ? 's' : ''}`
                                            : ''}
                                        { pricingModel.breakdown[0].duration % 24 !== 0 ? ` ${pricingModel.breakdown[0].duration % 24} hour${pricingModel.breakdown[0].duration % 24 > 1 ? 's' : ''}` : ''}
                                    </strong>
                                }
                                { offeringType == 1 && 
                                    <strong>{getTimeDifference(startDate,untilDate,"hours")} hours</strong>
                                }
                            </div>
                        </div>
                    </div>

                     
                          

               {/* </LoadingOverlay> */}
           </div>
        );
    }
    
}

BookingConfirmationForm.propTypes = {

    isLoading: PropTypes.bool,
    locationDetail:PropTypes.object,
    handleDateChange:PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        locationDetail: state.locationDetail,
    };
}

export default connect(
    mapStateToProps,
    null
  )(BookingConfirmationForm);




// WEBPACK FOOTER //
// ./src/forms/BookingConfirmationForm.jsx